<template>
  <div>
    <v-overlay :opacity="1" :value="overlay" class="default_overlay">
      <Loading />
    </v-overlay>
    <v-app>
      <v-main class="gray">
        <div class="logo-header px-4 container">
          <div class="d-flex align-center" data-cy="headerUlekareLogo">
            <Logo :height="16" :is-clickable="true" />
          </div>
        </div>
        <slot />
      </v-main>
      <v-footer
        v-if="!isMobileApp"
        :color="footerWhite ? 'white' : 'undefined'"
        class="pa-0"
        data-cy="footer"
        tag="div"
      >
        <HomepageFooter />
      </v-footer>
      <ErrorModal />
      <UnsupportedBrowserModal id="unsupported-browser-modal" />
      <UnavailableClinics />
      <CookiesDialog />
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import outsideClientZone from '~/mixins/layouts/outsideClientZone';
import HomepageFooter from '~/components/Organisms/Homepage/HomepageFooter.vue';
import authUserWatcher from '~/mixins/authUserWatcher';
import Loading from '~/components/Atoms/Loading.vue';
import ErrorModal from '~/components/Atoms/ErrorModal.vue';
import UnsupportedBrowserModal from '~/components/Atoms/UnsupportedBrowserModal.vue';
import UnavailableClinics from '~/components/Atoms/UnavailableClinics.vue';
import CookiesDialog from '~/components/Organisms/CookiesDialog.vue';
import NeedHelpFab from '~/components/Molecules/NeedHelpFab.vue';

export default {
  name: 'InfoPageLayout',
  components: {
    NeedHelpFab,
    CookiesDialog,
    UnavailableClinics,
    UnsupportedBrowserModal,
    ErrorModal,
    Loading,
    HomepageFooter
  },
  mixins: [outsideClientZone, authUserWatcher],
  data() {
    return {
      overlay: true
    };
  },
  metaInfo: {
    script: [
      {
        src: import.meta.env.MODE === 'production' ? '/linkedin-tracking-code.js' : '',
        body: true
      }
    ]
  },
  computed: {
    ...mapGetters({
      footerWhite: 'general/footerWhite',
      token: 'apiToken/token'
    }),
    whiteBg() {
      return (
        (this.currentPath === 'login' && !this.$auth.user) ||
        (this.currentPath === 'registration' && !this.$route.query.step)
      );
    }
  },
  beforeMount() {
    this.setIsUlHc(this.$route.name.indexOf('aeskuLab') !== -1);
  },
  mounted() {
    const allowedMobileAppRoutes = ['verifyEmail', 'emergency'];

    if (this.isMobileApp && !allowedMobileAppRoutes.includes(this.currentPath)) {
      if (this.$auth.loggedIn) {
        this.$router.replace(this.$localePath('dashboard'));
      }
    }
    this.overlay = false;
    const headerEnd = document.querySelector('.header-end');
    if (headerEnd) {
      const observer = new IntersectionObserver(entries => {
        this.$store.dispatch('general/setIsScrolled', !entries[0].isIntersecting);
      });
      observer.observe(headerEnd);
    }
  },
  methods: {
    ...mapMutations({
      setIsUlHc: 'general/setIsUlHc'
    })
  }
};
</script>

<style lang="scss">
body .v-overlay--active.default_overlay {
  z-index: 14 !important;
  min-height: 100dvh !important;

  .v-overlay__scrim {
    opacity: 1 !important;
    background-color: $white !important;
    border-color: $white !important;
  }
}

html {
  scroll-behavior: smooth !important;
}

.logo-header {
  height: 80px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    height: 60px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
}
</style>
